import type { Collection } from 'state/utils/types';

export type TradeStatus = 'PENDING' | 'FAILED' | 'REJECTED' | 'DONE';

export type TradeState = Readonly<{
  status: TradeStatus;
  tradeDate?: string;
  errorMessage?: string;
}>;

export type TradeMap = Collection<TradeState>;

export const initialTradeMap = {};
